<template>
  <div style="background:#fff">
    <!-- 头部 -->
    <el-row>
      <el-col :span="4">
        <el-button type="primary" class="width_btn" @click="back"
          >返回</el-button
        >
      </el-col>
      <el-col :span="16" style="text-align:center">
        <span class="title">调房调级申请</span>
      </el-col>
      
      <el-col class="border_gray border_padding">
        <div class="left_title">
          <div class="react"></div>
          <span>老人基本信息</span>
        </div>
        <el-row class="oldname">
          <el-col :span="12">
            <span class="star">*</span>
            <span class="text">老人姓名</span>
            <el-autocomplete
              v-model.trim="selectOldName"
              auto-complete="off"
              placeholder="请选择老人"
              style="width: 250px"
              :fetch-suggestions="querySearchAsync"
              @select="handleOlderSelect"
            ></el-autocomplete>
          </el-col>
          <el-col :span="12">
            <div class="oldname">
              <span class="midtext">身份证号</span>
              <span class="border">{{ olderIDCard }}</span>
            </div>
          </el-col>

        </el-row>
      </el-col>

      <el-col class="border_gray">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>调整前</span>
        </div>

        <table border="0px" width="100%" class="six">
          <tr>
            <td>类别</td>
            <td>项目</td>
            <td>项目金额</td>
            <td>收费类型</td>
            <td>实收金额</td>
          </tr>
          <tr v-for="item in olderBeforeChooseList" :key="item.id">
            <td> {{ item.itemType }} </td>
            <td>{{ item.itemName}}</td>
            <td>{{ item.originalPrice}}</td>
            <td>{{item.typeStr }}</td>
            <td>{{item.actualPrice}}</td>
          </tr>
        </table>

      </el-col>

      <el-col class="border_gray">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>调整为</span>
        </div>

        <table border="0px" width="100%" class="six">
          <tr>
            <td>类别</td>
            <td>项目</td>
            <td>项目金额</td>
            <td>收费类型</td>
            <td>实收金额</td>
          </tr>
          <tr v-for="(item, index) in newChargeList" :key="index">
            <td>
              {{ item.name }}
            </td>
            <td>
              <template>
                <!-- 床位费 -->
                <el-input
                  v-if="item.code == 1"
                  @click.native="chooseRoomBed(item,index);"
                  v-model="item.chooseItem.remark"
                  readonly
                ></el-input>
                <!-- 单选的 -->
                <el-select
                  v-else-if="item.canMultipleChoose == 0"
                  v-model="item.chooseItem.itemId"
                  style="width:100%"
                  @change="selectSingleFee(item, index, item.chooseItem.itemId)">
                  <el-option
                    v-for="itemss in item.expenseItemList"
                    :key="itemss.id"
                    :label="itemss.itemName"
                    :value="itemss.id"
                  ></el-option>
                </el-select>
                <!-- 多选的 -->
                <el-input
                  v-else-if="item.canMultipleChoose == 1"
                  @click.native="chooseMulitDialog(item, index);"
                  v-model="item.chooseItem.itemName"
                  readonly
                ></el-input>
              </template>
            </td>
            <td>{{ item.chooseItem!=null ? item.chooseItem.originalPrice :""}}</td>
            <td>{{ item.chooseItem!=null ? item.chooseItem.typeStr :"" }}</td>
            <td>
              <el-input
                v-model="item.chooseItem.actualPrice"
                v-on:input="
                  controlInputFee(item, index,item.chooseItem.actualPrice);
                "
              ></el-input>
            </td>
          </tr>
        </table>
      </el-col>

      <el-col class="border_gray border_padding">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>调整原因</span>
        </div>
        <el-row>
          <el-col :span="12" class="labelpadding">
            <span class="width120">调整原因</span>
            <el-select class="width200" v-model="reasonSelect">
              <el-option label="身体条件变差" value="1"> </el-option>
              <el-option label="老人不适应" value="2"> </el-option>
              <el-option label="主动调整" value="3"> </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="labelpadding">
            <span class="width120">调整日期</span>
            <el-date-picker
              v-model="changeData"
              value-format="yyyy-MM-dd"
              class="width200"
              @change="justDataSelect"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-col>
        </el-row>
      </el-col>

      <el-col class="border_gray border_padding">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>费用补缴</span>
        </div>
        <el-row>
          <el-col :span="12" class="labelpadding">
            <span class="width120">补缴天数</span>
            <el-input
              readonly
              class="width200"
              v-model="payDay"
            ></el-input>
          </el-col>
          <el-col :span="12" class="labelpadding">
            <span class="width120">调整差额</span>
            <el-input
              readonly
              class="width200"
              v-model="showFeeData.diffMoney"
            ></el-input>
          </el-col>
          <el-col :span="12" class="labelpadding">
            <span class="width120">总天数</span>
            <el-input
              readonly
              class="width200"
              v-model="cycleTotalDays"
            ></el-input>
          </el-col>
          <el-col :span="12" class="labelpadding">
            <span class="width120">补缴金额</span>
            <el-input
              readonly
              class="width200"
              v-model="showFeeData.totalFee"
            ></el-input>
          </el-col>
        </el-row>
      </el-col>

      <el-col style="display:flex;justify-content:center;margin: 30px 0px">
        <el-button type="warning" @click="back">取消</el-button>
        <el-button type="primary" @click="submitAdd" :loading="submitAddLoading"
          >确认</el-button>
      </el-col>
    </el-row>

    <!-- 多选框选择 -->
    <el-dialog title="选择" :visible.sync="mulixChooseVisible">
      <el-table
        ref="multipleTable"
        id="multipleTable"
        :data="mulixItemList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="itemName" label="项目名称"> </el-table-column>
        <el-table-column prop="content" min-width="200" label="内容">
        </el-table-column>
        <el-table-column prop="chargeStandard" label="收费标准">
        </el-table-column>
        <el-table-column
          prop="costType"
          :formatter="formatType"
          label="收费方式"
        >
        </el-table-column>
        <el-table-column prop="remark" min-width="100" label="备注"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mulixChooseVisible = false;">取 消</el-button>
        <el-button type="primary" @click="mulixChooseEnter">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 房间床位选择弹窗 -->
    <el-dialog
      title="床位选择"
      style="margin-top:-10vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="room_dialog"
      :visible.sync="roomBeddialogVisible"
      width="80%"
    >
      <el-row>
        <span style="margin-left:20px">正式入住:{{ checkIn }}人</span>
        <span style="margin-left:20px">空床:{{ nullBed }}张</span>
        <span style="margin-left:20px">已预约:{{ order }}张</span>
        <span style="margin-left:20px">试入住:{{ tryIn }}人</span>
        <span style="margin-left:30px">楼栋:</span>
        <el-select
          v-model="buildName"
          placeholder="请选择"
          style="width:120px"
          @change="selectRoomdialogShow"
        >
          <el-option
            v-for="item in BuildList"
            :key="item.value"
            :label="item.buildingName"
            :value="item.buildingName"
          ></el-option>
        </el-select>
        <img
          src="@/assets/beadhouse/nan.png"
          style="display:inline-block;vertical-align:middle;margin-left:30px;"
        />
        <span>男</span>
        <img
          src="@/assets/beadhouse/nv.png"
          style="display:inline-block;vertical-align:middle;margin-left:20px;"
        />
        <span>女</span>
        <img
          src="@/assets/beadhouse/kongchuang_icon.png"
          style="display:inline-block;vertical-align:middle;margin-left:20px;"
        />
        <span>空床</span>
        <img
          src="@/assets/beadhouse/yiyuyue.png"
          style="display:inline-block;vertical-align:middle;margin-left:20px;"
        />
        <span>已预约</span>
      </el-row>
      <el-row>
        <room-bed-show
          v-bind:yuyue="2"
          v-bind:floorlist="floorList"
          v-bind:type="2"
          @getChildRoomBedData="clickRoomBedData"
        ></room-bed-show>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import util from "@/utils/util";
import bus from "@/vuex/eventBus";
import RoomBedShow from "@/components/RoomBedShow"; //引入第三方组件
export default {
  name: "ReviseAdd",
  components: {
    RoomBedShow
  },
  data() {
    return {
      submitAddLoading: false, //点击确定的loading
      loading: false,
      olderList: [], //老人列表
      chargeList: [], //机构的收费类别列表
      feeTableData:[], // 总费用列表清单
      olderBeforeChooseList: [], //调房调级前的列表
      newChargeList: [], //新的可调整的列表
      changeData: "",
      payDay:"",//剩余天数
      cycleTotalDays : "", //周期总天数
      reasonSelect: "",
      buildName: "",
      BuildList: [], //楼栋列表
      floorList: [], //楼层房间列表
      currentFloorList: [], //当前楼层房间床位列表
      oldmanBedRoomBuildingVo: {}, //老人的床位信息
      pakeageData: {}, //套餐数据
      roomBeddialogVisible: false,
      selectOldName:"",
      selectOldId:"",
      olderBirthday: "",
      olderIDCard: "", //身份证
      bedFeeList: {}, //床位费列表
      newBedId: "", //选择的床位Id
      newBedNo: "", //选择的床位编号
      oldBedId: "", //旧的
      mulixChooseVisible: false, //多选框弹窗
      mulixCheckList: [], //选中的 多选框 数据
      mulixItemList: [], //全部的多选框 的数据
      currentFeeitem: {}, //当前床位费的整个item
      currentIndex: 0, //当前操作的项 item index;
      beforeTotalFee: 0, //调整前费用总和
      //房间入住情况
      checkIn: "0",
      nullBed: "0",
      order: "0",
      tryIn: "0",
      //end
      showFeeData: {
        days: 0, //补缴天数
        pakeageTuiFee: 0, //套餐退费金额
        diffMoney: 0, //差额
        leaveDay: 0, //请假天数
        leaveTuiFee: 0, //请假退费
        totalFee: 0 //总费用
      },
      cycleTotalDays: 0, //退费公式 周期总天数  分母天数
      pickerOptions0: {
        disabledDate(time) {
          var d = new Date();
          var ydate = (d.getFullYear())
          var mdate = (d.getMonth() + 1)
          var day = new Date(ydate, mdate, 0).getDate()
          mdate = mdate > 9 ? mdate : '0' + mdate
          day = day > 9 ? day : '0' + day
          var end_date = `${ydate}-${mdate}-${day}`
          let start = new Date()
          let end = new Date(end_date)
          let ks = start.getTime(start) -1000*60*60*24;
          var js = end.getTime(end)
          return time.getTime()>js || time.getTime()<ks
        }
      }
    };
  },
  methods: {
    back() {
      bus.$emit("close_current_tags");
    },
    //提交申请
    submitAdd() {
      if (this.reasonSelect == "") {
        this.$message({ type: "error", message: "请选择调整原因" });
        return;
      }
      if (this.changeData == "") {
        this.$message({ type: "error", message: "请选择调整日期" });
        return;
      }
      var groupPaymentFeeDtoList = []; //调整后的项目;
      this.newChargeList.forEach(item=>{
        if(item.chooseItem!=null && item.chooseItem.itemName!=null){
          groupPaymentFeeDtoList.push({
            expenseItemId:item.chooseItem.id,
            originFee: item.chooseItem.originalPrice,
            actualFee:item.chooseItem.actualPrice,
            type: item.chooseItem.type, 
            itemType: item.chooseItem.itemType, 
            itemName: item.chooseItem.itemName, 
          })
        }
      })
      var info = {
        oldmanId: this.selectOldId,
        reason: this.reasonSelect,
        date: this.changeData, 
        payDays: this.payDay,
        leaveDays: this.cycleTotalDays,
        agio: Number(this.showFeeData.diffMoney).toFixed(2),
        total: Number(this.showFeeData.totalFee).toFixed(2),
        groupPaymentFeeDtoList: groupPaymentFeeDtoList,
        bedId: this.newBedId
      };
      console.log(info);
      this.submitAddLoading = true; //by guo 2019-12-09-11:49添加
      this.$postJson("fmc/revise/addRevise",info).then(
        res => {
          this.$message({ type: "success", message: "调整申请成功" });
          this.back();
          //by guo 2019-12-09-11:49添加
          setTimeout(() => {
            this.submitAddLoading = false;
          }, 100);
        },
        err => {
          this.$message({ type: "error", message: err.message });
          //by guo 2019-12-09-11:49添加
          setTimeout(() => {
            this.submitAddLoading = false;
          }, 100);
        }
      );
    },
    //性别转换
    formatType: function(row, column) {
      //1-元/次 2-元/天 3-元/月 4-元/年
      if (row.costType == 1) {
        return "元/次";
      } else if (row.costType == 2) {
        return "元/天";
      } else if (row.costType == 3) {
        return "元/月";
      } else if (row.costType == 4) {
        return "元/年";
      }
    },
    //取小数点二位
    fixTwo(data) {
      if (data != null) {
        return Number(data).toFixed(2);
      } else {
        return "";
      }
    },

    //获取楼层信息
    getBuildList() {
      this.$postForm("omc/Building/showAlls").then(res => {
        console.log(res);
        this.BuildList = res.result;
        this.buildName = res.result[0].buildingName; //初始化房间楼栋
      });
    },
    //处理楼层全部数据
    controlFloorData() {
      //为了一个房间太多床位的显示异常
      let floorList = [];
      for (let i = 0; i < this.currentFloorList.length; i++) {
        let roomList = [];
        //获取房间列表
        for (let j = 0; j < this.currentFloorList[i].roomList.length; j++) {
          let pageList = [];
          this.currentFloorList[i].roomList[j] = this.getBedSrc(
            this.currentFloorList[i].roomList[j]
          );
          let allBedList = this.currentFloorList[i].roomList[j].bedList;

          //切割数组,然后进行分页添加上去
          for (var k = 0; k < allBedList.length; k += 4) {
            var bedList = allBedList.slice(k, k + 4);
            pageList.push({
              bedList: bedList
            });
          }
          let roomData = {
            roomno: this.currentFloorList[i].roomList[j].roomNo,
            roomId: this.currentFloorList[i].roomList[j].roomId,
            roomType: this.currentFloorList[i].roomList[j].roomType,
            hasToilet: this.currentFloorList[i].roomList[j].hasToilet,
            pageList: pageList
          };
          roomList.push(roomData);
        }

        let floorData = {
          floorNo: this.currentFloorList[i].floorNo,
          roomList: roomList
        };
        floorList.push(floorData);
      }
      this.floorList = floorList;
      this.roomBeddialogVisible = true;
    },
    //根据房间和床位,设置它的src,如果需要修改显示的逻辑,请修改这里
    getBedSrc(roomData) {
      roomData.bedList.forEach(bedItem => {
        //试入住
        if (bedItem.status == 5) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/shiruzhu_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/shiruzhu_nv.png");
          }
        }
        //入住
        if (bedItem.status == 2) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/nv.png");
          }
        }

        //预约
        if (bedItem.status == 3) {
          bedItem.src = require("@/assets/beadhouse/yiyuyue.png");
        }

        //调整中
        if (bedItem.status == 6) {
          bedItem.src = require("@/assets/beadhouse/tiaozhengzhong_nan.png");
        }
        //空床
        if (bedItem.status == 0) {
          bedItem.src = require("@/assets/beadhouse/kongchuang_icon.png");
        }

        //待缴费
        if (bedItem.status == 7) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nv.png");
          }
        }
      });
      return roomData;
    },
    //获取楼层房间床位列表
    getBuildFloorList() {
      this.$postForm("omc/Room/showAll", { buildingId: this.buildId }).then(
        res => {
          if (res.result != null) {
            this.currentFloorList = res.result.floorList;
          } else {
            this.currentFloorList = [];
          }
          this.controlFloorData();
        }
      );

      this.$postJson("omc/Bed/queryBedStatus/" + this.buildId).then(res => {
        //初始化床位数量
        (this.checkIn = "0"),
          (this.nullBed = "0"),
          (this.order = "0"),
          (this.tryIn = "0"),
          console.log(res);
        for (var i = 0; i < res.result.length; i++) {
          if (res.result[i].status == 0) {
            this.nullBed = res.result[i].count;
          } else if (res.result[i].status == 5) {
            this.tryIn = res.result[i].count;
          } else if (res.result[i].status == 2) {
            this.checkIn = res.result[i].count;
          } else if (res.result[i].status == 3) {
            this.order = res.result[i].count;
          }
        }
      });
    },
    
    //选择楼栋
    selectRoomdialogShow() {
      let aa = this.BuildList;
      let build = this.BuildList.filter(item => {
        return item.buildingName == this.buildName;
      });
      this.floorList = build[0].floorList;
      this.buildId = build[0].buildingId;
      this.getBuildFloorList();
    },
    //点击弹出弹窗
    chooseRoomBed(item,index) {
      this.currentFeeitem = item;
      this.currentIndex = index;
      this.selectRoomdialogShow();
    },
    //选择床位的回显
    clickRoomBedData(data) {
      //chooseBedId
      console.log(data);
      if (data.bedtype.status != 0) {
        this.$message({ type: "error", message: "请选择空床位" });
        return;
      }
      if (data.type == 2) {
        this.newBedId = data.bedid;
        this.newBedNo = data.bedno;
        this.roomBeddialogVisible = false;
      }
      var roomType = data.roomInfo.roomType;
      var hasToilet = data.roomInfo.hasToilet;
      console.log(this.currentFeeitem);
      let itemone = Object.assign({},this.currentFeeitem);  
      let chooseItem = {};
      //匹配到床位费
      let isPiPei = false;
      // var costprecent = this.bedFeeList.precent / 100;
      for (var i = 0; i < this.bedFeeList.expenseItemList.length; i++) {
        if (this.bedFeeList.expenseItemList[i].roomType == roomType) {
          isPiPei = true;
          chooseItem = {
            itemName: this.bedFeeList.expenseItemList[i].itemName,
            itemType: this.bedFeeList.name,
            remark: this.newBedNo,
            itemId: this.bedFeeList.expenseItemList[i].id,
            originalPrice: this.bedFeeList.expenseItemList[i].chargeStandard,
            actualPrice: this.bedFeeList.expenseItemList[i].chargeStandard,
            type: this.bedFeeList.expenseItemList[i].costType == 3?2:1,
            typeStr: this.bedFeeList.expenseItemList[i].costType == 3 ?"按月扣费":"按天扣费"
          }
          itemone.chooseItem = chooseItem;
          this.$set(this.newChargeList,this.currentIndex,itemone)
          this.computeAllTotalFee();
          break;
        }
      }
      if (!isPiPei) {
        this.$message({
          type: "error",
          message: "请在费用管理中添加对应的床位费类型"
        });
      }
    },
    
    /**切换多选框 */
    handleSelectionChange(val) {
      this.mulixCheckList = val;
    },
    chooseMulitDialog(item, index) {
      // item.feeData.expenseItemList  全部的
      // item.itemList //选中的
      this.mulixChooseVisible = true;
      this.currentFeeitem = item;
      this.currentIndex = index;
      this.mulixItemList = item.expenseItemList;
      this.mulixCheckList = [];
      //newChargeList
      var chargeList = [];
      for (var i = 0; i < this.newChargeList.length; i++) {
        if (this.newChargeList[i].id == item.id) {
          chargeList.push(Object.assign({}, this.newChargeList[i]));
        }
      }
      //延迟
      setTimeout(() => {
        this.$refs.multipleTable.clearSelection();
        for (var i = 0; i < item.expenseItemList.length; i++) {
          for (var j = 0; j < chargeList.length; j++) {
            if (
              item.expenseItemList[i].itemName ==
              chargeList[j].chooseItem.itemName
            ) {
              this.mulixCheckList.push(item.expenseItemList[i]);
              //设置默认选中
              this.$refs.multipleTable.toggleRowSelection(
                this.mulixItemList[i]
              );
              break;
            }
          }
        }
      }, 50);
    },
    //多选的enter按钮
    mulixChooseEnter() {
      let newFeeList = Object.assign([],this.newChargeList);
      for(let i=newFeeList.length-1; i>0; i--){
        if(newFeeList[i].id == this.currentFeeitem.id){
          newFeeList.splice(i, 1);
        }
      }
      let isHaveSpecial = false;
      for(let j =0; j< this.mulixCheckList.length; j++){
          isHaveSpecial = true;
          let feeData2 = Object.assign({},this.currentFeeitem);
          feeData2.chooseItem = {
            itemName: this.mulixCheckList[j].itemName,
            itemType: this.currentFeeitem.name,
            itemId: this.mulixCheckList[j].id,
            originalPrice: this.mulixCheckList[j].chargeStandard,
            actualPrice: this.mulixCheckList[j].chargeStandard,
            type: this.mulixCheckList[j].costType == 3?2:1,
            typeStr: this.mulixCheckList[j].costType == 3 ?"按月扣费":"按天扣费"
          };
          newFeeList.push(feeData2)      
      }
      if(!isHaveSpecial){
        let feeData = Object.assign({},this.currentFeeitem);
        feeData.chooseItem = {}; 
        newFeeList.push(feeData)
      }
      this.newChargeList = newFeeList;
      this.mulixChooseVisible = false;
      //重新计算费用
      this.computeAllTotalFee();
    },

    //选择单项服务项目
    selectSingleFee(item,index, val) {
      let itemone = Object.assign({},item);
      let chooseItem = {};
      for (var i = 0; i < itemone.expenseItemList.length; i++) {
        if (val == itemone.expenseItemList[i].id) {
          chooseItem = {
            //{actualPrice:2400 itemName:"自理服务"itemType:"护理费"oldmanId:"5360"originalPrice:3000remark:""type:2typeStr:"按月扣费"}
            itemName: itemone.expenseItemList[i].itemName,
            itemType: itemone.name,
            itemId: itemone.expenseItemList[i].id,
            originalPrice: itemone.expenseItemList[i].chargeStandard,
            actualPrice: itemone.expenseItemList[i].chargeStandard,
            type: itemone.expenseItemList[i].costType == 3?2:1,
            typeStr: itemone.expenseItemList[i].costType == 3 ?"按月扣费":"按天扣费"
          }
          itemone.chooseItem = chooseItem;
        }
      }
      // this.newChargeList[index].chooseItem = chooseItem;
      this.$set(this.newChargeList,index,itemone)
      //重新计算费用
      this.computeAllTotalFee();
    },

    //控制输入的减免费用,去掉其他字符串,限制输入大小,校验完成
    controlInputFee(item,index, inputFee) {
      console.log(item.chooseItem);
      var re = /([0-9]+\.[0-9]{2})[0-9]*/;
      inputFee = inputFee.replace(re, "$1");
      if (inputFee.indexOf(".") != -1) {
        inputFee = inputFee.substring(0, inputFee.indexOf(".") + 3);
      }
      inputFee = inputFee.replace(/[^\d.]/g, "");
      inputFee = inputFee.replace(/\.{2,}/g, ".");
      inputFee = inputFee.replace(/^\./g, "0.");
      if (
        inputFee != 0 &&
        inputFee.indexOf("0.") != 0 &&
        inputFee.indexOf("0") == 0
      ) {
        inputFee = inputFee.substring(1, inputFee.length);
      }
      item.chooseItem.actualPrice = inputFee;
      console.log(inputFee);
      this.$set(this.newChargeList,index,item)
      // this.computeAllTotalFee();
    },
    //调整日期的选择事件
    justDataSelect(val) {
      //yyyy-mm-dd
      if (val != null && val != "") {
        this.getShowDays(val);
        // this.computeAllTotalFee();
      } else {
        this.changeData == "";
        this.showFeeData = {
          days: 0, //补缴天数
          pakeageTuiFee: 0, //套餐退费金额
          diffMoney: 0, //差额
          leaveDay: 0, //请假天数
          leaveTuiFee: 0, //请假退费
          totalFee: 0 //总费用
        };
      }
    },

    //获取差额天数
    getShowDays(val) {
      var data = {
        reviseDate: val
      };
      this.$post("fmc/revise/queryReviseDays", data, "", "json").then(res => {
        if (res != null) {
          this.payDay = res.payDays;
          this.cycleTotalDays = res.cycleTotalDays;
        } else {
          this.payDay = 0;
          var d = new Date();
          var curMonthDays = new Date(d.getFullYear(), (d.getMonth() + 1), 0).getDate();
          this.cycleTotalDays = curMonthDays;
        }
        this.computeAllTotalFee();
      });
    },
    //计算最终费用
    computeAllTotalFee() {
      //获取调整前项目
      //获取调整后项目
      //获取调整日期;
     
      if(this.payDay == ""){
        return;
      }
      // 只能选今天和今天以后的; 
      // 查找按月扣费的项目
      // 按天的不需要退 实际调整后自动变化
      let bfTotal = 0;
      let atTotal = 0;
      this.olderBeforeChooseList.forEach(item=>{
        if(item.type == 2){
          bfTotal = Number(bfTotal) + Number(item.actualPrice);
        }
      })
      this.newChargeList.forEach(item=>{
        if(item.chooseItem!=null && item.chooseItem.type == 2){
          atTotal = Number(atTotal) + Number(item.chooseItem.actualPrice);
        }
      })
      console.log(atTotal);
      console.log(bfTotal);
      console.log(this.payDay);
      console.log(this.cycleTotalDays);
      let fee = (Number(atTotal - bfTotal ) * Number(this.payDay *1) / Number(this.cycleTotalDays * 1)).toFixed(2);
      this.showFeeData.diffMoney = fee;
      this.showFeeData.totalFee = fee;
      console.log(this.newChargeList);

    },
    // 最新获取到调整前后的费用的方式
    showOlderTwoFee(olderChooseData) {
      this.olderBeforeChooseList = []; //之前的项目列表
      let beforeList = [];
      let afterList = [];
      for(let j =0; j< olderChooseData.length; j++){
        let beforeItem = Object.assign({},olderChooseData[j]);
        if(beforeItem.itemType == "床位费"){
          //床位费
          if(beforeItem.remark ==null || beforeItem.remark == ""){
            beforeItem.remark = beforeItem.itemName;
          }
        }
        beforeItem.typeStr =  beforeItem.type == 1?"按天扣费":"按月扣费";
        beforeList.push(beforeItem)
      }       
      //mulitStr 
      for (let i = 0; i < this.feeTableData.length; i++) {
        let feeData = this.feeTableData[i];
        let choose = {};
        if(feeData.code == 1){
          for(let j =0; j< olderChooseData.length; j++){
            if(feeData.name == olderChooseData[j].itemType){
              //床位费
              choose = olderChooseData[j];
              if(choose.remark ==null ||  choose.remark == ""){
                choose.remark = choose.itemName;
              }
            }
          }
          feeData.chooseItem = choose; 
          afterList.push(feeData)
        }else if(feeData.canMultipleChoose == 1){
          let isHave = false;
          for(let j =0; j< olderChooseData.length; j++){
            if(feeData.name == olderChooseData[j].itemType){
              isHave = true;
              let feeData2 = Object.assign({},this.feeTableData[i]);
              feeData2.chooseItem = olderChooseData[j];
              afterList.push(feeData2)      
            }
          }
          if(!isHave){
            feeData.chooseItem = {}; 
            afterList.push(feeData)
          }
        }else{
          for(let j =0; j< olderChooseData.length; j++){
            if(feeData.name == olderChooseData[j].itemType){
              choose = olderChooseData[j];      
              choose.itemId = 0;
              feeData.expenseItemList.forEach(item3=>{
                if(item3.itemName == olderChooseData[j].itemName){
                  choose.itemId = item3.id;
                }
              })
            }
          }
          feeData.chooseItem = choose; 
          afterList.push(feeData)
        }
      }
      this.olderBeforeChooseList = beforeList;
      afterList.forEach(item=>{
        item.chooseItem.typeStr = item.chooseItem.type == 1?"按天扣费":"按月扣费";
      })
      this.newChargeList = afterList;
      //得到调整后的
    },
    //切换老人后清除全部数据
    clearOlderFeeData() {
      this.reasonSelect = "";
      this.changeData = "";
      this.payDay = "";
      this.cycleTotalDays = "";
      this.showFeeData = {
        days: 0, //补缴天数
        pakeageTuiFee: 0, //套餐退费金额
        diffMoney: 0, //差额
        leaveDay: 0, //请假天数
        leaveTuiFee: 0, //请假退费
        totalFee: 0 //总费用
      };
    },
    //根据老人id获取费用详情
    showFeeList(id) {
      let olderBean = this.olderList.filter(item => {
        return item.oldmanId == id;
      });
      this.olderBirthday = olderBean[0].birthday;
      this.olderIDCard = olderBean[0].idCard;
      this.clearOlderFeeData();
      //获取老人的床位id;
      //omc/Bed/selectByOldId
      this.$postForm("omc/Bed/selectByOldId",{
        oldmanId: id,
      }).then(res=>{
        if(res.result!=null){
          this.newBedId = res.result.bedId;
          this.newBedNo = res.result.roomNo + "-"+res.result.bedno;
        }else{
          this.newBedId = "";
          this.newBedNo = "";
        }
      })
      //omc/revise/queryByOldmanId/
      this.$postJson("fmc/elderFeeConfig/queryBindFeeList",{
        oldId: id,
      }).then(
        res => {
          this.oldmanFeeList = res.result;
          this.showOlderTwoFee(this.oldmanFeeList);
        },
        err => {
          this.$message({ type: "error", message: err.message });
        }
      );
    },

    /* 
    模糊查询老人
    */
    querySearchAsync(queryString, cb) {
      let param = {
        oldmanName: this.selectOldName,
        pageNum:1,
        pageSize:20
      };
      this.$postJson("fmc/revise/queryOldmanList", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldmanName; //将想要展示的数据作为value
          }
          list = res.result.list;
          this.olderList = list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.selectOldName = "";
          }, 1000);
        }
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.selectOldId = item.oldmanId;
      this.showFeeList(item.oldmanId)
    },
    //获取数据列表
    getOlderList() {
      // let param = {
      //   oldmanName: this.selectOldName,
      //   pageNum:1,
      //   pageSize:1
      // };
      // this.$postJson("omc/revise/queryOldmanList", param).then(
      //   res => {
      //     this.olderList = res.result.list; //老人列表
      //     //默认选中第一个
      //     this.selectOldId = this.olderList[0].oldmanId;
      //     this.selectOldName = this.olderList[0].oldmanName;
      //     //费用详情
      //     this.showFeeList(this.selectOldId);
      //   },
      //   err => {
      //     this.$message({ type: "error", message: err.message });
      //   }
      // );
    },
    //获取费用数据
    getFeeData() {
      this.$postJson("fmc/feeItem/queryAllTypes").then(
        (res) => {
          console.log(res, "查询类别以及消费项");
          if (res.code == 200) {
            if (res.result.length > 0) {
              let tableData = [];
              res.result.forEach(item => {
                if(item.code == 1 || item.code == 2 || item.code == 3){
                  item.hospitalFeeForm = {};
                  tableData.push(item);
                }
                if(item.code == 1){
                  this.bedFeeList = item;
                }
              });
              this.feeTableData = tableData;
            }
          }
        });
    }
  },
  mounted() {
    this.getBuildList();
    this.getFeeData();
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.header_padding {
  margin-bottom: 5px;
}
.radio {
  margin: 5px;
}
.width_btn {
  height: 28px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  padding: 5px 30px;
}
.title {
  text-align: center;
  color: #0064ea;
  font-size: 20px;
}
.room_dialog ::v-deep .el-dialog__header {
  padding: 8px 20px 8px;
}
.border_gray {
  border: 1px solid #dddddd;
  border-radius: 5px;
  margin-top: 20px;
  padding-left: 1px;
  padding-right: 1px;
  box-shadow: 2px 2px 4px #ccc;
}
.border_padding {
  padding: 10px 5px;
}
.margin_border {
  margin: 10px 5px;
}

.left_title {
  display: flex;
  align-items: center;
  .react {
    width: 4px;
    height: 26px;
    background: #3a77e2;
    margin-left: 10px;
    margin-right: 8px;
  }
  span {
    font-size: 18px;
  }
}
.oldname {
  margin-left: 50px;
  margin-top: 10px;
  .star {
    color: red;
  }
  .text {
    margin-left: 13px;
    font-size: 16px;
    margin-right: 20px;
  }
  .midtext {
    font-size: 16px;
  }
  .border {
    border: 1px solid #ddd;
    width: 200px;
    padding: 6px 10px;
    display: inline-block;
    margin-left: 10px;
  }
}
.labelpadding {
  padding-left: 50px;
  margin-top: 10px;
}
.width120 {
  width: 120px;
  display: inline-block;
}
.width200 {
  width: 200px;
}
.top30 {
  margin-top: 30px;
}
table {
  text-align: center;
  line-height: 36px;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  border-color: #fff;
  td {
    border: 1px solid #ddd;
    width: 16.66%;
  }
}
</style>
